import { useContext } from 'react'
import { Divider, Drawer, Toolbar } from '@mui/material'
import { LayoutContext } from '../../contexts/LayoutContext'
import { Path } from '../../types/Path'
import { SidebarContent } from './SidebarContent'
import { ItemColorProps } from './SidebarListItem'

export interface TempSidebarProps {
  title?: string
  listItems?: Path[]
  basePath?: string
  colors?: ItemColorProps
}

export function SidebarDrawer({
  title,
  listItems,
  basePath,
  colors,
}: TempSidebarProps) {
  const { sidebar } = useContext(LayoutContext)
  const drawerWidth = 240

  return (
    <Drawer
      variant='temporary'
      open={sidebar.open}
      onClick={sidebar.toggle}
      sx={{
        width: drawerWidth,
        border: 'none',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'backgroundDrawer',
          backgroundImage: 'none',
        },
      }}
    >
      <Toolbar />
      <Divider />

      <SidebarContent
        title={title}
        listItems={listItems}
        basePath={basePath}
        colors={colors}
      />
    </Drawer>
  )
}
